import { Component, OnInit } from '@angular/core';
import { VERSION } from '../../../environments/version';

type VersionInfo = {
  dirty: boolean;
  raw: string;
  hash: string;
  distance: null | number;
  tag: null | string;
  suffix: string;
  semverString: null | string;
  version: null | string;
};

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})

/**
 * Footer component
 */
export class FooterComponent implements OnInit {
  year: number = new Date().getFullYear();
  commit: string | undefined = undefined;
  version: string | undefined = undefined;

  ngOnInit() {
    const src = VERSION as VersionInfo;
    this.commit = `${src.hash}`;
    this.version = `${src.version || src.tag}`
  }
}
